const product3dShowConfig = {
  'product3dShow.back': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '返回',
    c: {
      type: 'constant',
      value: 'off_design',
    },
  },
  'product3dShow.design_perspective.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_perspective',
    },
  },
  'product3dShow.design_perspective.touch': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'design_perspective',
    },
  },
  'product3dShow.design_tab': {
    operation: ['VISIBLE', 'Touch'],
    c: {
      type: 'constant',
      value: 'design_tab',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'product3dShow.tab_select': {
    operation: ['Touch', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'design_choose',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.d;
      },
    },
  },
  'product3dShow.view_details': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'view_details',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.view_details.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'view_details',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.purchase': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'purchase',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.purchase.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'purchase',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.fold_control.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'fold_control',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.fold_control.touch': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'fold_control',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.3d.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: '3d',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.3d.touch': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: '3d',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.ar.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'ar',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.ar.touch': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'ar',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.snapshot_share.visible': {
    operation: ['VISIBLE'],
    c: {
      type: 'constant',
      value: 'snapshot_share',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
  'product3dShow.snapshot_share.touch': {
    operation: ['Touch'],
    c: {
      type: 'constant',
      value: 'snapshot_share',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `skus=${traceData.skus}`;
      },
    },
  },
};
export default product3dShowConfig;
